import React from "react";
import { useTranslation } from "react-i18next";

import loanImg from "../../../../assets/loan-simulator.jpg";
import installmentImg from "../../../../assets/monthly-installment.jpg";
import renCostImg from "../../../../assets/renovation-cost.jpg";

import "./SimulationCards.css";

function SimulationCard({
  image,
  tag,
  title,
  description,
  onPrimary,
}) {
  const activate = () => {
    onPrimary?.();
  };

  const handleKeyDown = (event) => {
    if (
      event.key !== "Enter" &&
      event.key !== " "
    ) {
      return;
    }

    event.preventDefault();
    activate();
  };

  return (
    <div
      className="flip-card"
      role="button"
      tabIndex={0}
      aria-label={title}
      onClick={activate}
      onKeyDown={handleKeyDown}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="simulation-card__image-wrapper">
            <img
              src={image}
              alt=""
              className="simulation-card__image"
              aria-hidden="true"
            />

            <span className="simulation-card__tag">
              {tag}
            </span>
          </div>

          <h3 className="simulation-card__title">
            {title}
          </h3>
        </div>

        <div className="flip-card-back">
          <p className="simulation-card__description">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function SimulationCards({
  onSelect,
}) {
  const { t } = useTranslation(
    "select-service",
    {
      keyPrefix:
        "selectSimulation",
    },
  );

  return (
    <section className="select-simulation__wrapper">
      <h1 className="select-simulation__title">
        {t("title")}
      </h1>

      <p className="select-simulation__subtitle">
        {t("subtitle")}
      </p>

      <div className="select-simulation__cards">
        <SimulationCard
          image={loanImg}
          tag={t("loan.tag")}
          title={t("loan.title")}
          description={t(
            "loan.description",
          )}
          onPrimary={() =>
            onSelect?.("loan")
          }
        />

        <SimulationCard
          image={installmentImg}
          tag={t("installment.tag")}
          title={t(
            "installment.title",
          )}
          description={t(
            "installment.description",
          )}
          onPrimary={() =>
            onSelect?.("installment")
          }
        />

        <SimulationCard
          image={renCostImg}
          tag={t("renCost.tag")}
          title={t("renCost.title")}
          description={t(
            "renCost.description",
          )}
          onPrimary={() =>
            onSelect?.("renCost")
          }
        />
      </div>
    </section>
  );
}
